import {OrderDepthLevelRecord, OrderDepths} from "../types/OrderDepthRecord";
import {ascendingUsing, descendingUsing} from "../../js/util/UtilFunctions";

export class OverlappingMarket {

    constructor(public readonly matchPrice: number,
                public readonly matchVolume: number,
                public readonly remainingVolume: number) {
    }

    public static calculate(bids: OrderDepths, asks: OrderDepths): OverlappingMarket | null {
        const b = bids.map((bid) => new OffsetOrderDepthModel(bid));
        b.sort(descendingUsing((bid) => bid.price));

        const a = asks.map((ask) => new OffsetOrderDepthModel(ask));
        a.sort(ascendingUsing((ask) => ask.price));

        let matchVolume = 0;
        let lastBid: OffsetOrderDepthModel | null = null;
        let lastAsk: OffsetOrderDepthModel | null = null;

        for (let i = 0; i < b.length; i++) {
            const left = b[i];

            for (let j = 0; j < a.length; j++) {
                const right = a[j];

                if (!left.hasRemainingVolume || left.price < right.price) {
                    break;
                }

                if (right.hasRemainingVolume) {
                    matchVolume += left.offset(right);
                    lastBid = left;
                    lastAsk = right;
                }
            }
        }

        if (lastBid == null || lastAsk == null) {
            return null;
        }

        // TODO need to confirm if we are matching buyers vs sellers or the other way
        const matchPrice = lastAsk.price;
        const remainingBidVolume = lastBid.remainingVolume;
        const remainingAskVolume = lastAsk.remainingVolume;
        const remainingVolume = remainingBidVolume || remainingAskVolume;

        return new OverlappingMarket(matchPrice, matchVolume, remainingVolume);
    }
}

class OffsetOrderDepthModel {
    private _remainingVolume: number;

    constructor(private readonly model: OrderDepthLevelRecord) {
        this._remainingVolume = model.volume;
    }

    public get price() {
        return this.model.price;
    }

    public get remainingVolume(): number {
        return this._remainingVolume;
    }

    public get hasRemainingVolume(): boolean {
        return this._remainingVolume > 0;
    }

    public offset(other: OffsetOrderDepthModel): number {
        const offsetVolume = Math.min(this.remainingVolume, other.remainingVolume);
        this._remainingVolume -= offsetVolume;
        other._remainingVolume -= offsetVolume;

        return offsetVolume;
    }
}
